{
  "INTEGRATION_APPS": {
    "FETCHING": "Integracijų gavimas",
    "NO_HOOK_CONFIGURED": "Šioje paskyroje nesukonfigūruota jokių {integrationId} integracijų.",
    "HEADER": "Programos",
    "STATUS": {
      "ENABLED": "Leisti",
      "DISABLED": "Išjungta"
    },
    "CONFIGURE": "Konfigūruoti",
    "ADD_BUTTON": "Pridėkite naują hook",
    "DELETE": {
      "TITLE": {
        "INBOX": "Patvirtinti Ištrynimą",
        "ACCOUNT": "Atsijungti"
      },
      "MESSAGE": {
        "INBOX": "Ar tikrai norite ištrinti?",
        "ACCOUNT": "Ar tikrai norite atsijungti?"
      },
      "CONFIRM_BUTTON_TEXT": {
        "INBOX": "Taip, Ištrinti",
        "ACCOUNT": "Taip, Atsijungti"
      },
      "CANCEL_BUTTON_TEXT": "Atšaukti",
      "API": {
        "SUCCESS_MESSAGE": "Webhook ištrintas sėkmingai",
        "ERROR_MESSAGE": "Nepavyko prisijungti prie Woot serverio, bandykite dar kartą vėliau"
      }
    },
    "LIST": {
      "FETCHING": "Integravimo webhook gavimas",
      "INBOX": "Gautų laiškų aplankas",
      "EDIT": {
        "BUTTON_TEXT": "Redaguoti"
      },
      "DELETE": {
        "BUTTON_TEXT": "Ištrinti"
      }
    },
    "ADD": {
      "FORM": {
        "INBOX": {
          "LABEL": "Pasirinkti gautų laiškų aplanką",
          "PLACEHOLDER": "Pasirinkti gautų laiškų aplanką"
        },
        "SUBMIT": "Sukurti",
        "CANCEL": "Atšaukti"
      },
      "API": {
        "SUCCESS_MESSAGE": "Integravimo kwebhook pridėtas sėkmingai",
        "ERROR_MESSAGE": "Nepavyko prisijungti prie Woot serverio, bandykite dar kartą vėliau"
      }
    },
    "EDIT": {
      "TITLE": "Redaguoti {name}",
      "FORM": {
        "SUBMIT": "Atnaujinti",
        "CANCEL": "Atšaukti"
      },
      "API": {
        "SUCCESS_MESSAGE": "Integracijos hook sėkmingai atnaujintas",
        "ERROR_MESSAGE": "Nepavyko prisijungti prie Woot serverio, bandykite dar kartą vėliau"
      }
    },
    "CONNECT": {
      "BUTTON_TEXT": "Sujungti"
    },
    "DISCONNECT": {
      "BUTTON_TEXT": "Atsijungti"
    },
    "SIDEBAR_DESCRIPTION": {
      "CUSTOM_DATA_PROVIDER": "Fetch data from your own server and display it in the conversation sidebar. Returns HTML (shown in an iframe) or JSON (shown as a key/value list).",
      "DIALOGFLOW": "Dialogflow is a natural language processing platform for building conversational interfaces. Integrating it with {installationName} lets bots handle queries first and transfer them to agents when needed. It helps qualify leads and reduce agent workload by answering FAQs. To add Dialogflow, create a Service Account in Google Console and share the credentials. Refer to the docs for details",
      "DAKTELA": "Sinchronizuokite el. laiškus ir svetainės pokalbius su savo daktela paskyra.",
      "RETINO": "Retino sutvarko grąžinimų ir pretenzijų valdymą.",
      "MAILSHIP": "Mailship yra sandėlio ir užsakymų vykdymo valdymo sistema. Peržiūrėkite užsakymo būseną, sekimo ir siuntimo informaciją.",
      "RAYNET": "Prijunkite savo Raynet CRM paskyrą, kad galėtumėte pasiekti klientų duomenis. Pridėkite ryšį naudodami Raynet naudotojo vardą ir API raktą."
    },
    "TEST_CONNECTION": {
      "BUTTON": "Tikrinti ryšį",
      "SUCCESS": "Ryšys sėkmingas",
      "ERROR": "Nepavyko prisijungti. Patikrinkite savo prisijungimo duomenis."
    }
  }
}
